import type { DirectiveBinding } from 'vue';

export const tooltipFnMap = new WeakMap<HTMLElement, () => string>();

const XTooltipDirective = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        if (typeof binding.value === 'function') {
            tooltipFnMap.set(el, binding.value);
            el.setAttribute('data-tooltip', '');
        } else if (typeof binding.value === 'string') {
            tooltipFnMap.set(el, () => binding.value);
            el.setAttribute('data-tooltip', '');
        }
    },
    updated(el: HTMLElement, binding: DirectiveBinding) {
        if (typeof binding.value === 'function') {
            tooltipFnMap.set(el, binding.value);
        } else if (typeof binding.value === 'string') {
            tooltipFnMap.set(el, () => binding.value);
        }
    },
    unmounted(el: HTMLElement) {
        tooltipFnMap.delete(el);
        el.removeAttribute('data-tooltip');
    },
};

export default XTooltipDirective;
